import { render, staticRenderFns } from "./CreateLegalBasis.vue?vue&type=template&id=6cebe710&"
import script from "./CreateLegalBasis.vue?vue&type=script&lang=js&"
export * from "./CreateLegalBasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports